import React, { useEffect, useReducer } from 'react';
import { MobileContext } from './context';
import { defaultState, reducer } from './state';
import { useNavigate, useParams } from 'react-router-dom';
import { useAppContext } from '@/provider/contexts';
import { fetchStoreDetailAPI } from '@/api/stores';

export const MobileProvider = ({ children }: { children: React.ReactNode }) => {
    const [state, dispatch] = useReducer(reducer, defaultState);
    const { manageStoreId, setManageStoreId } = useAppContext();
    const { storeId } = useParams<{ storeId: string }>();
    const navigate = useNavigate();

    useEffect(() => {
        setManageStoreId(Number(storeId));
    }, [storeId]);

    useEffect(() => {
        const fetchStoreDetails = async () => {
            if (!manageStoreId) {
                return;
            }

            dispatch({ type: 'SET_STORE_LOADING', payload: true });

            try {
                const {
                    data: { data, isSuccess },
                } = await fetchStoreDetailAPI(manageStoreId);
                if (isSuccess) {
                    dispatch({
                        type: 'SET_STORE_DETAILS',
                        payload: {
                            info: data.store_info || {},
                            settings: data.store_settings || {},
                        },
                    });
                    return;
                }
                setManageStoreId(null);
                localStorage.setItem('manageStoreId', '');
                localStorage.removeItem('hasMultiStore');
                navigate('/mobile/select-store', { replace: true });
            } catch (error) {
                console.error('Error fetching store details:', error);
            } finally {
                dispatch({ type: 'SET_STORE_LOADING', payload: false });
            }
        };
        fetchStoreDetails();
    }, [manageStoreId]);

    return <MobileContext.Provider value={{ state, dispatch }}>{children}</MobileContext.Provider>;
};
